import React from 'react';

// Single source of truth for the public App Store link on the marketing site.
// (SharedSummaryPage keeps its own constant; consolidate when that page is next touched.)
export const APP_STORE_URL = 'https://apps.apple.com/app/clarime/id6759699245';

const AppleLogo = ({ className }) => (
  <svg className={className} viewBox="0 0 384 512" fill="currentColor" aria-hidden="true">
    <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.7-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
  </svg>
);

/**
 * App Store download badge (black pill, Apple mark, two-line label).
 * Used in the landing page hero, the bottom CTA, and the #/get page.
 */
export default function AppStoreBadge({ className = '' }) {
  return (
    <a
      href={APP_STORE_URL}
      aria-label="Download ClariMe on the App Store"
      className={`inline-flex items-center gap-3 px-6 py-3.5 bg-slate-900 text-white rounded-2xl shadow-lg shadow-slate-900/20 hover:bg-black hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all ${className}`}
    >
      <AppleLogo className="w-7 h-7" />
      <span className="text-left leading-tight">
        <span className="block text-[11px] font-medium text-white/75 tracking-wide">Download on the</span>
        <span className="block text-xl font-semibold -mt-0.5">App Store</span>
      </span>
    </a>
  );
}
